import React from 'react';
import { Truck, Zap, PhoneCall } from 'lucide-react';
import { STORE_CONFIG } from '../../config/storeConfig';

export const PromoTrustBar: React.FC = () => {
  return (
    <div
      id="promo-trust-bar"
      className="w-full bg-[#FF6987] py-2 sm:py-2.5 px-4 text-white font-bold text-xs sm:text-[13px] tracking-wider shadow-xs"
    >
      <div className="max-w-7xl mx-auto flex flex-wrap items-center justify-center gap-y-1.5 gap-x-4 sm:gap-x-8 text-center uppercase">
        <div className="flex items-center gap-1.5">
          <Truck className="w-4 h-4 text-amber-200 shrink-0" />
          <span>Cash on Delivery</span>
        </div>

        <span className="text-white/60 hidden sm:inline">|</span>

        <div className="flex items-center gap-1.5">
          <Zap className="w-4 h-4 text-amber-300 shrink-0 fill-amber-300" />
          <span>Fast Shipping All Pakistan</span>
        </div>

        <span className="text-white/60 hidden sm:inline">|</span>

        <a
          id="promo-support-link"
          href={`tel:${STORE_CONFIG.phone}`}
          className="flex items-center gap-1.5 hover:text-white/90 transition-colors"
        >
          <PhoneCall className="w-4 h-4 text-white shrink-0" />
          <span>24/7 Support: {STORE_CONFIG.phoneDisplay}</span>
        </a>
      </div>
    </div>
  );
};
